<template>
  <div ref="customFieldCheck" v-if="this.CustomFields.length > 0">
    <b-row>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col md="12">
        <h3>Additional Details</h3>
      </b-col>
    </b-row>
    <b-form @change="fieldChanges">
      <b-row ref="additionalFields">
        <b-col md="12" v-for="(item, index) in CustomFields" :id="item.ordering" :key="item.ordering">
          <b-form-group :label="item.fieldName" label-for="fieldname">
            <b-form-input id="fieldname" :type="item.fieldType" :placeholder="item.fieldName" :readonly="ReadOnlyFields"
              :disabled="ReadOnlyFields" v-model="item.fieldValue" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormTextarea,
  BFormSelect,
  BFormFile,
  BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { mapGetters, mapActions } from "vuex/";
import { readonly } from "@vue/composition-api";

export default {
  components: {
    // validation rules
    required,
    BRow,
    BFormSelect,
    BCol,
    ToastificationContent,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BButton,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    ModuleReference: {
      type: String,
      required: true,
    },
    AdditionalFields: {
      type: Array,
      required: true,
    },
    ReadOnlyFields: {
      type: Boolean,
      default: false, // Default to editable
    },
  },
  data() {
    return {
      defaultField: [
        {
          ordering: 0,
          fieldName: null,
          fieldValue: null,
          fieldType: "text",
          isRequired: false,
          displayEcomm: false,
        },
      ],
      CustomFields: [],
      Sections: [],
      nextOrdering: 1,
    };
  },
  methods: {
    ...mapActions("customFieldsModule", ["getCustomFieldsListAction"]),
    fieldChanges() {
      // Emit changes only if not readonly
      if (!this.ReadOnlyFields) {
        this.$emit("onchange", this.CustomFields);
      }
    },
  },
  computed: {
    ...mapGetters("customFieldsModule", {
      customFields: "customFields",
      loadingCustom: "loading",
    }),
  },
  async mounted() {
    await this.getCustomFieldsListAction({
      section: this.ModuleReference,
      payload: this.ModuleReference,
    });
    this.CustomFields = this.customFields(this.ModuleReference);
    console.log("🚀 ~ mounted ~ this.CustomFields:", this.CustomFields);

    if (this.AdditionalFields != null) {
      console.log("🚀 ~ AdditionalFields:", this.AdditionalFields);
      this.CustomFields.forEach((x) => {
        const matchedField = this.AdditionalFields.find((y) => y.id === x.id);

      // Set fieldValue explicitly as null or empty string if undefined
      if (matchedField && matchedField.fieldValue != null) {
        x.fieldValue = matchedField.fieldValue; // Use the actual value
      } else {
        x.fieldValue = ""; // Explicitly set as empty string
      }
    });
      this.fieldChanges();
    } else {
      console.log("🚀 ~ custom fields got undefined AdditionalFields");
    }
  },
};
</script>